const keyMirror = require('keymirror');

import { getBackdrop, getSprite, getCostume, getSound, getTag } from '../lib/http';

const Types = keyMirror({
    SET_CUSTOM_BACKDROP: null,
    SET_CUSTOM_SPRITE: null,
    SET_CUSTOM_COSTUME: null,
    SET_CUSTOM_SOUND: null,
    SET_CUSTOM_TAG: null
})

const initialState = {
    customBackdrop: null,
    customSprite: null,
    backdrops: null,
    sprites: null,
    costumes: null,
    sounds: null,
    tags: null
}

const reducer = (state, action) => {
    if (typeof state === 'undefined') {
        state = initialState;
    }
    switch (action.type) {
        case Types.SET_CUSTOM_BACKDROP:
            return {
                ...state,
                customBackdrop: action.material
            };
        case Types.SET_CUSTOM_SPRITE:
            return {
                ...state,
                customSprite: action.material
            };
        case Types.SET_CUSTOM_COSTUME:
            return {
                ...state,
                costumes: action.payload
            };
        case Types.SET_CUSTOM_SOUND:
            return {
                ...state,
                sounds: action.payload
            };
        case Types.SET_CUSTOM_TAG:
            return {
                ...state,
                tags: action.payload
            };
        default:
            return state;
    }
}

const setCustomBackdrop = value => ({
    type: 'SET_CUSTOM_BACKDROP',
    material: value
})

const setCustomSprite = value => ({
    type: 'SET_CUSTOM_SPRITE',
    material: value
})

const setCustomCostume = payload => ({
    type: 'SET_CUSTOM_COSTUME',
    payload: payload
})

const setCustomSound = payload => ({
    type: 'SET_CUSTOM_SOUND',
    payload: payload
})

const setCustomTag = payload => ({
    type: 'SET_CUSTOM_TAG',
    payload: payload
})

const getCustomBackdrop = () => dispatch => {
    return getBackdrop().then(res => {
        const { data } = res;

        if (data && Array.isArray(data?.data)) {
            dispatch(setCustomBackdrop(data?.data || []));
        }
    })
}

const getCustomSprite = () => dispatch => {
    return getSprite().then(res => {
        const { data } = res;
        if (data && Array.isArray(data?.data)) {
            dispatch(setCustomSprite(data?.data || []));
        }
    })
}

const getCustomCostume = () => dispatch => {
    return getCostume().then(res => {
        const { data } = res;
        if (data && Array.isArray(data?.data)) {
            dispatch(setCustomCostume(data?.data || []));
        }
    })
}

const getCustomSound = () => dispatch => {
    return getSound().then(res => {
        const { data } = res;
        if (data) {
            dispatch(setCustomSound(data?.data || []));
        }
    })
}

const getCustomTag = () => dispatch => {
    return getTag().then(res => {
        const { data } = res.data;
        if (data) {
            dispatch(setCustomTag(data || []));
        }
    })
}

export {
    reducer as default,
    initialState as customMaterialInitialState,
    getCustomBackdrop,
    getCustomSprite,
    getCustomCostume,
    getCustomSound,
    getCustomTag
}
